import clsx from 'clsx';
import Icon from './Icon';
import styles from '../../styles/components/atoms/WebLink.module.scss';

interface WebLinkProps {
  icon?: string;
  label?: string;
  href: string;
}

export default function WebLink(props: WebLinkProps) {
  let { label, icon, href } = props;
  const { weblink } = styles;
  const classes = clsx(weblink);
  const smedia = ['Facebook', 'Instagram', 'Twitter', 'Youtube', 'Linkedin'];
  const currLabel =
    label ||
    smedia.filter((str) => href.indexOf(str.toLowerCase()) > -1)[0] ||
    href;
  const currIcon =
    icon || (currLabel.indexOf('@') > -1 ? 'email' : currLabel.toLowerCase());

  if (icon === 'phone') {
    href = `tel:${href}`;
  } else if (icon === 'email') {
    href = `mailto:${href}`;
  } else if (icon === 'linkedin' && href.includes('/') === false) {
    href = `https://www.linkedin.com/${href}`;
  } else if (icon === 'twitter' && href.includes('/') === false) {
    href = `https://twitter.com/${href}`;
  } else if (icon === 'youtube' && href.includes('/') === false) {
    href = `https://www.youtube.com/${href}`;
  }

  if (!href.includes(':')) {
    href = `https://${href}`;
  }

  return (
    <span className={classes}>
      <Icon name={currIcon} />
      <small>
        <a href={href} target='_blank' rel='noopener, noreferrer'>
          {currLabel}
        </a>
      </small>
    </span>
  );
}
